export default __webpack_public_path__ + "static/media/logo_teamit.44a18beb.svg";